import FallbackLight from '../assets/job_postings/Fallback-light.png';
import {isUrlValid} from '../utils/urlUtils/isUrlValid';

export const useFallBackLogo = (url?: string): string => {
  const getLogoUrl = (url: string | undefined): string | undefined => {
    const baseUrl = process.env.REACT_APP_OBJECT_STORAGE_BASE_URL || '';
    if (url && !url.startsWith(baseUrl)) {
      return `${baseUrl}/${url}`;
    }
    return url;
  };

  // Check if the URL is valid
  const logoUrl = getLogoUrl(url);
  if (logoUrl && isUrlValid(logoUrl)) {
    return logoUrl;
  }

  return FallbackLight;
};
